const insertGoogleScriptTag = googleMapsKey => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&libraries=places`;
  document.body.appendChild(script);
};

export default insertGoogleScriptTag;
